/*
 * File: InputZip.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Input Zip Element
 */
import React from "react";
import PropTypes from "prop-types";
import UITextField from "components/ui/UITextField";

const InputZip = ({ field, value, error, parentOnChange }) => {

  const materialInputProps = {
    ...field.materialInputProps,
  };

  return (
    <React.Fragment>
      <UITextField
        name={field.name}
        error={error}
        value={value}
        materialInputProps={materialInputProps}
        htmlInputProps={field.htmlInputProps}
        placeholder={field.placeholder}
        parentOnChange={parentOnChange}
        label={field.label}
      />
    </React.Fragment>
  );
};

InputZip.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  parentOnChange: PropTypes.func
};

export default InputZip;
